import { render, staticRenderFns } from "./SubEventRegistrants.vue?vue&type=template&id=eedf6fba"
import script from "./SubEventRegistrants.vue?vue&type=script&lang=js"
export * from "./SubEventRegistrants.vue?vue&type=script&lang=js"
import style0 from "./SubEventRegistrants.vue?vue&type=style&index=0&id=eedf6fba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports